import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

export class fontAwesomeIcons {
	static setup = () => {
		library.add(fas);
	};
}
